import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
const resources = {
  english: {
    translation: {
      registration_form: "REGISTRATION FORM",
      retreat_team: "Are you Retreatant Couple or a Team Couple ?",
      retreatant: "Retreatant",
      team: "Team",
      check_year:
        "If you AND your spouse are BOTH 35 years of age or younger, please check this box. Please note that ID confirmation may be requested.",
      yes: "Yes",
      his_info: "His Info",
      her_info: "Her Info",
      his_first_name: "His First Name",
      her_first_name: "Her First Name",
      his_last_name: "His Last Name",
      her_last_name: "Her Last Name",
      his_email: "His Email",
      her_email: "Her Email",
      email: "Email",
      his_mobile: "His Mobile",
      her_mobile: "Her Mobile",
      mobile: "Mobile",
      address: "Address",
      state: "State",
      city: "City",
      zip: "Zip Code",
      parish: "Parish",
      anniversary_date: "Anniversary Date (Month/Year)",
      notes: "Notes",
      dietary_allergies:
        "Do you or your spouse have any dietary allergies, dietary restrictions or physical limitations?",
      one_emergency_contact: "Please provide at least one emergency contact:",
      name: "Name",
      relationship: "Relationship",
      phone: "Phone",
      hear_us: "How did you hear about us?",
      website: "Website",
      church_bulletin: "Church Bulletin",
      facebook: "Facebook",
      school_marquee: "School Marquee",
      Pulpit_church: "Pulpit Talk/Table in Church",
      referral: "Referral from a friend/Family member",
      release_statement:
        "By checking the boxes of this clause immediately below, we, the LOVESTRONG Retreat participants, hereby release, waive, and forever discharge LOVESTRONG Marriage, the Hosting Parish/Church, and the Archdiocese of San Antonio, and any of their directors, officers, employees, and their agents (collectively “Releasees”) from all liability for any and all loss or damage, and any claim or demands therefore on account of injury, death or property damage or loss, now and forever, arising out of or related to the undersigned retreatants participation in and/or presence at the LOVESTRONG Marriage Retreat, including any of its associated sessions, activities, and operations that may occur, whether caused by the negligence of releasees or otherwise.",
      register: "Register",
      add_one_name: "Please add at least one name.",
      least_email_id: "Please add at least one email ID.",
      couple_register_retreat_msg: "Thank you for Retreat Registration!",
      select_state: "Select State",
      select_parish: "Select Parish...",
      mission_statement: "Our Mission Statement:",
      upcoming_retreat: "UPCOMING RETREAT",
      retreat_leadership: "Retreat Leadership",
      all_retreat_couples: "All Retreat Couples",
      all_couples_expected_msg:
        "All Retreat Couples are expected to attend the entire {{count}}-day weekend's activities.",
      questions: "Questions?",
      need_help: "Need help?",
      retreat_schedule: "Retreat Schedule",
      our_mission: "Our Mission",
      hosting_parish: "Hosting Parish",
      visit_parish_website: "Visit Parish Website",
      day: "Day",
      date: "Date",
      start: "Start",
      end: "End",
      lead_couple: "Lead Couple",
      co_lead_couple: "Co-Lead Couple",
      shadow_lead_couple: "Shadow Lead Couple",
      spiritual_director: "Spiritual Director (Priest/Deacon)",
      spiritual_mentor: "Spiritual Mentor",
      mentor_couple: "Mentor Couple",
      husband_acknowledgment: "Husband acknowledgment",
      wife_acknowledgment: "Wife acknowledgement",
      acknowledgmentAlertMsg: "Please acknowledge before submitting!",
      release_statement_title: "Release Statement",
      search_mail_field:
        "Enter Your Registered Email Id if you are already a Lovestrong Member:",
      search_mail_placeholder: "Enter Email",
      his_name: "His Name:",
      his_email: "His Email:",
      her_name: "Her Name:",
      her_email: "Her Email:",
      alert_msg: "Is this your information?",
      cancel_button: "No, this is not our information",
      okay_button: "Yes, this is our information",
      register_retreat: "Register Retreat",
      matched_mail:
        "Please check your information, you can edit and register for the Retreat.",
      not_matched_mail:
        "Please enter your information in the below Retreat Registration form.",
      okay_alert_msg: "Okay",
      highlighted_text: "(Fields highlighted in yellow are required.)",
      ret_team_selection: "Please select either a Retreatant or a Team Couple.",
      mobile_used: "This Mobile is already used.",
      already_registered:
        "You are already registered for this Retreat with this Email id.",
      mail_already_exist_in_db:
        "This Email does not exist in the database. Please enter your information in the below form.",
      help: "HELP",
      post_a_ticket: "Post a Ticket",
      first_name: "First Name",
      last_name: "Last Name",
      subject: "Subject",
      message: " Message / Issue",
      enter_captcha: "Enter Captcha",
      enter_your_name: "Enter your first name",
      enter_your_last_name: "Enter your last name",
      enter_your_email: "Enter your email",
      enter_your_mobile: "Enter your mobile number",
      enter_ticket_subject: "Enter ticket subject",
      describe_detail:
        "Please make sure to explain your problem, issue, or question in detail…",
      type_captcha_here: "Type captcha here",
      all_required_fields: "Please fill all required fields",
      failed_to_create_ticket: "Failed to create ticket",
      invalid_captcha: "Invalid captcha",
      ticket_successfully: "Ticket created successfully",
      cancel: "Cancel",
      select_category: "Select Category",
      ticket_category: "Ticket Category",
      retreat_registration: "Retreat Registration",
      retreat_financials: "Retreat Financials",
      retreat_roster: "Retreat Roster",
      retreat_closure: "Retreat Closure",
      database_issues: "Database Issues",
      retreat_reports: "Retreat Reports",
      request_to_feature: "Request to Feature",
      how_do_i: "How do I...",
      other: "Other",
      attachments: "Attachments",
      allowed: "(JPG, MP4, AVI allowed)",
      selected_files: "Selected files",
      invalid_email: "Invalid email",
      files_are_invalid: "These files are invalid",
      category_reqired: "Category is required",
      three_mb_size: "size should be less than 3 MB",
      ten_mb_size: "size should be less than 10 MB",
      invalid_type: "(invalid type)",
      anniversary_date_required: "Anniversary Date is required!",
      dietary_allergies_required:
        "Please provide dietary allergies, dietary restrictions, or any physical limitations.",
      parish_required: "Parish is required!",
      register_new_retreat: "Register New Retreat",
      enter_Parish_name: "Enter the Parish Name",
      select_retreat_language: "Select Retreat Language",
      language_required: "Language is required!",
      enter_location: "Enter Location",
      location_required: "Location is required!",
      retreat_theme: "Retreat Theme",
      retreat_theme_required: "Retreat Theme is required!",
      retreat_img_size: "(Image size should not be greater than 3 MB.)",
      upload_retreat_image: "Upload Retreat Image",
 retreat_image_upload_tooltip_size:
  "Preferred maximum image dimensions:",

retreat_image_upload_tooltip_landscape:
  "Landscape: 1920 × 1080 px",

retreat_image_upload_tooltip_portrait:
  "Portrait: 1080 × 1620 px",

retreat_image_upload_tooltip_square:
  "Square: 1620 × 1620 px",

retreat_image_upload_tooltip_file_size:
  "File size must not be greater than 3 MB.",

retreat_image_upload_tooltip_formats:
  "Accepted formats: JPG, JPEG, PNG, WebP, and HEIC (where supported). PDF is not accepted.",

retreat_image_upload_tooltip_aria:
  "Retreat image upload requirements",
      edit_retreat: "Edit Retreat",
      remove: "Remove",
      friday: "Friday",
      from: "From",
      date_required: "Atleast one date is required!",
      time_from_required: "Time From is required!",
      to: "To",
      time_to_required: "Time To is required!",
      time_from_time_to_should_not_be_same:
        "Time From' and 'Time To' should not be the same.",
      saturday: "Saturday",
      sunday: "Sunday",
      description: "Description",
      description_sample: "Description Sample",
      description_sample_tip:
        "Helpful Tip: Copy & Paste this description onto your registration form and make sure to change the Church name, email address and cell phone numbers to your own.",
      description_required: "Description is required!",
      email_message: "Email Message",
      email_preview: "Email Preview",
      sample_email_message: "Sample Email Message",
      retreat_payment_link: "Retreat Payment Link",
      retreat_team: "Retreat Team",
      payment_link_required: "Payment link is required!",
      contact_information: "Contact Information",
      enter_name: "Enter Name",
      contact_name: "Contact Name",
      contact_name_required: "Contact Name is required!",
      contact_email: "Contact Email",
      contact_email_required: "Contact Email is required!",
      mobile_number: "Mobile Number",
      contact_mobile_required: "Contact Mobile is required!",
      retreat_administrators: "Retreat Administrators",
      retreat_file_size: "File size should be less than 3 MB",
      preview_email: "Preview Email",
      Retreat_administrators_tooltip:
        "Retreat Administrators manage the retreat data. The Lead, Co-Lead, and Mentor function as Retreat Administrators. The Super Admin has the authority to add additional Retreat Administrators.",
      location: "Location",
      no_couple_yet: "No couples added yet.",
      successfully_retreat_added: "Retreat added successfully.",
      atleast_one_date_required: "Atleast one Date is required.",
      retreat_already_exists: "Retreat already exists.",
      close: "Close",
      select_create_sub_admin_alert:
        "Please select or create at least one sub-admin.",
      submit: "Submit",
      select: "Select",
      remove_couple: "Remove Couple",
      first_name_required: "First Name is required.",
      title: "Title",
      email_required: "Email is required!",
      Registration_piritual_director:
        "Registration As a Spiritual Director (Priest)",
      registration_as_couple: "Registration As a Couple",
      dietary_allergies_priest:
        "Do you have any dietary allergies, dietary restrictions or physical limitations?",
      thank_you_retreat_registration: "Thank You for Retreat Registration!",
      We_will_review_and_confirm:
        "We will review and confirm you in the email.",
      thank_you_for_prtiest:
        "Thank You for Retreat Registration as a Spiritual Director (Priest)!",
      check_email_and_verify:
        "Please check your email and click the link to verify your email id.",
      wait_confirmation_aAdmin:
        "Please wait for confirmation email from the Admin",
      can_login_your_account:
        "You can login your account with below registered Email ids:",
      login: "Login",
      forget_password: "Forget Password",
      emergency_name_1: "Emergency Name 1",
      emergency_relationship_1: "Emergency Relationship 1",
      emergency_phone_1: "Emergency Phone 1",
      emergency_name_2: "Emergency Name 2",
      emergency_relationship_2: "Emergency Relationship 2",
      emergency_phone_2: "Emergency Phone 2",
      select_existing_couple: "Select Existing Couple",
      select_existing_priest: "Select Existing Priest",
      approve: "Approve",
      delete: "Delete",
      create_new_priest: "Add New Priest",
      spanish_name: "Spanish Name",
      retreat_program: "Retreat Program",
      table_of_contents: "TABLE OF CONTENTS",
      opening_prayer: "Opening Prayer",
      retreat_lead_team: "Retreat Lead Team",
      speakers: "Speakers",
      support_teams: "Support Teams",
      wisdom_mother_theresa: "Wisdom from Mother Theresa",
      wisdom_from_mother_theresa: "Wisdom from Mother Theresa",
      spiritual_mentor_couple: "Spiritual Mentor Couple",
      guidelines_sharing: "Guidelines for Sharing & Table Discussion",
      guidelines_sharing_table_discussion:
        "Guidelines for Sharing & Table Discussion",
      talk: "Talk",
      marriage_prayer_of_protection: "Marriage Prayer of Protection",
      lovestrong_donations: "LOVESTRONG DONATIONS",
      opening_prayer_content: `<h1 style="text-align: center"><span style="font-size: 36px">LOVESTRONG</span></h1><h2 style="text-align: center;line-height: 2"><span style="font-size: 24px">Opening Prayer</span></h2><p style="text-align: center"><span style="font-size: 18px"><strong><br></strong></span></p><p style="text-align: center"><span style="font-size: 18px"><strong>Thank you Dear Lord, for this day and this time as we</strong></span></p><p style="text-align: center"><strong><span style="font-size: 18px">come together with our spouses and friends.</span></strong></p><p style="text-align: center"><strong><span style="font-size: 18px">Bless this ministry through Your Guidance, wisdom and counsel,</span></strong></p><p style="text-align: center"><strong><span style="font-size: 18px">so it may flourish and grow within our community.</span></strong></p><p style="text-align: center"><strong><span style="font-size: 18px">We ask that Your spirit dwell within us to be humble stewards</span></strong></p><p style="text-align: center"><strong><span style="font-size: 18px">and servants so that Your graces may flow abundantly</span></strong></p><p style="text-align: center"><strong><span style="font-size: 18px">to all those marriages in need of Your help.</span></strong></p><p style="text-align: center"><strong><span style="font-size: 18px">May Your presence always be with us as we ask this in</span></strong></p><p style="text-align: center"><strong><span style="font-size: 18px">Your most precious and Holy Name.</span></strong></p><p style="text-align: center"><span style="font-size: 18px"><strong>Amen.</strong></span></p>`,
      prayer_protection_content: `<h1 style="text-align: center"><span style="font-size: 36px">LOVESTRONG</span></h1><h2 style="text-align: center;line-height: 2"><span style="font-size: 24px">Marriage Prayer of Protection</span></h2><p style="text-align: center"><span style="font-size: 18px"><strong><br></strong></span></p><p style="text-align: center"><span style="font-size: 18px"><strong>Dear Heavenly Father, we thank You for our marriage.</strong></span></p><p style="text-align: center"><strong><span style="font-size: 18px">We are so very blessed to have each other.</span></strong></p><p style="text-align: center"><strong><span style="font-size: 18px">Regardless of the conflicts we face,</span></strong></p><p style="text-align: center"><strong><span style="font-size: 18px">the trials and challenges…our marriage is a blessing.</span></strong></p><p style="text-align: center"><strong><span style="font-size: 18px">We pray for Your protection over our marriage.</span></strong></p><p style="text-align: center"><strong><span style="font-size: 18px">We ask that You strengthen our resolve to avoid any weak</span></strong></p><p style="text-align: center"><strong><span style="font-size: 18px">and selfish ways.</span></strong></p><p style="text-align: center"><strong><span style="font-size: 18px">Mature us and refine us so that we only</span></strong></p><p style="text-align: center"><strong><span style="font-size: 18px">seek the good of each other.</span></strong></p><p style="text-align: center"><strong><span style="font-size: 18px">We also pray for Your protection</span></strong></p><p style="text-align: center"><strong><span style="font-size: 18px">against the schemes of the enemy.</span></strong></p><p style="text-align: center"><strong><span style="font-size: 18px">Holy Spirit, cover us and anoint our marriage.</span></strong></p><p style="text-align: center"><strong><span style="font-size: 18px">Guide us, and help us to Love Strong</span></strong></p><p style="text-align: center"><strong><span style="font-size: 18px">and live out our Marital Sacrament.</span></strong></p><p style="text-align: center"><strong><span style="font-size: 18px">May compassion, love, and grace motivate our every action.</span></strong></p><p style="text-align: center"><strong><span style="font-size: 18px">In Jesus' name we pray.</span></strong></p><p style="text-align: center"><span style="font-size: 18px"><strong>AMEN!</strong></span></p>`,
      donations_content: `<h1 style="text-align: center;line-height: 2"><span style="font-size: 33px">LOVESTRONG DONATIONS</span><br></h1><p><span style="font-size: 18px">The LOVESTRONG Marriage Ministry is a 501(c)(3) Non-profit organization thatdepends entirely upon the assistance of generous donations from members of ourcommunity. This ministry cannot continue without your support. The Retreat Fees do notcover all the expenses it takes to put these retreats on. We are seeking donations whichwill be used as follows:</span><br><br><span style="font-size: 20px">Help LOVESTRONG grow here at St. Joseph - Honey Creek Catholic Church by..…</span><br></p><ul><li style="font-size: 18px">Covering the food, drinks, Facility Rental Fees, printing of all materials, etc.</li><li style="font-size: 18px">Securing retreat supplies, training materials, and hosting “Reunion DateNight” events.</li><li style="font-size: 18px">Subsidizing scholarships for couples who are unable to afford the retreat</li></ul><p style="line-height: 1.3rem"><span style="font-size: 20px">Help LOVESTRONG grow in our community by...</span><br></p><ul><li style="font-size: 18px">Hosting weekend retreats at new and first-time parishes<br></li><li style="font-size: 18px">Sponsoring pro bono retreats at parishes located in low-income areas<br></li></ul><p><br><span style="font-size: 18px">Please note that by using this QR Code, 80% of your donation will go to the Lovestrong program hereat St. Joseph’s. 20% will be used to support Lovestrong 501(c)(3) Outreach retreats in our community.<br><br>If you prefer to donate by check or cash, your Table Facilitator can give you a donation form andenvelope.</span><br></p>`,
      ministry: "MINISTRY",
      live_love_strong: "Live. Love. Strong.",
      parish_mission: "Parish Mission",
      our_parish_mission: "Our Parish Mission",
      donations: "Donations",
      remove: "Remove",
      footer_images: "Footer Images",
      back_cover_page: "Back Cover Page",
      back_cover_page_color: "Back Cover Page Color",
      choose_back_cover_page_color: "Choose back cover page color",
      download_qr_code: "Download QR Code",
      scan_for_more_info: "Scan for more information",
      download_pdf: "Download PDF",
      page: "Page",
      content_not_found_pdf: "Content not found for PDF generation",
      file_downloading: "File is Downloading, please wait...",
      file_downloaded: "File is Downloaded.",
      failed_generate_pdf: "Failed to generate PDF. Please try again.",
      edit: "Edit",
      copy_program_link: "Copy Program Link",
      image_upload: "Image Upload",
      lovestrong_marriage: "LOVESTRONG Marriage",
      header: "Header",
      parish_logo: "Parish Logo",
      select_role: "Select Role",
      select_priest: "Select Priest",
      select_couple: "Select Couple",
      select_talk: "Select Talk",
      select_service: "Select Service",
      add_guidelines: "Add Guidelines",
      talks_questions: "Talks Questions",
      talk_questions: "Talk questions",
      scripture: "Scripture",
      verse_placeholder: "Write the verse",
      citation_example: "Romans 12:12",
      add_item: "Add",
      questions_label: "Questions",
      question_placeholder: "Write a question",
      no_verses_yet: "No verses yet.",
      no_questions_yet: "No questions yet.",
      delete_this: "Delete this?",
      unsaved_worksheet: "You have unsaved changes.",
      discard: "Discard",
      keep_editing: "Keep editing",
      legacy_worksheet_notice:
        "This talk still uses the older free-form content. Saving here replaces it with scripture and questions.",
      move_up: "Move up",
      move_down: "Move down",
      worksheet_preview: "Preview",
      worksheet_editor_hint:
        "Write the scripture and the questions here. Use text color to change colors.",
      verse_required: "Write the verse before adding it.",
      question_required: "Write a question before adding it.",
      facebook_link: "Facebook Link",
      instagram_link: "Instagram Link",
      qr_code: "QR Code",
      upload_footer_images: "Upload footer images",
      save: "Save",
      close: "Close",
      example_link: "(example - https://www.xyz.com)",
      alert: "ALERT!!",
      confirm_color_change:
        "Are you sure you want to change the back cover page color?",
      no: "No",
      couple_suffix: " Couple",
      contact_info: "Contact Information",
      invalid_email_format: "Invalid email format",
      vaild_email_address: "Please enter valid email addresses.",
    },
  },
  spanish: {
    translation: {
      registration_form: "FORMULARIO DE INSCRIPCIÓN",
      retreat_team: "¿Son una pareja de retiro o una pareja de equipo?",
      retreatant: "Retiro",
      team: "Equipo",
      check_year:
        "Si usted y su cónyuge son menores de 35 años, por favor, verifique aquí. Identificación podría ser requerida.",
      yes: "Sí",
      his_info: "Información de el",
      her_info: "Información de ella",
      his_first_name: "Nombre de el",
      her_first_name: "Nombre de Ella",
      his_last_name: "Apellido (El)",
      her_last_name: "Apellido (Ella)",
      his_email: "Correo Electrónico (El)",
      her_email: "Correo Electrónico (Ella)",
      email: "Correo electrónico",
      his_mobile: "Celular (El)",
      her_mobile: "Celular (Ella)",
      mobile: "Móvil",
      address: "Dirección",
      state: "Estado",
      city: "Ciudad",
      zip: "Código postal",
      parish: "Parroquia / Iglesia",
      anniversary_date: "Fecha de aniversario (mes/año)",
      notes: "Notas",
      dietary_allergies:
        "¿Tiene usted o su cónyuge alguna alergia dietética, restricciones dietéticas o problemas físicos o limitaciones? Si es así, por favor explique.",
      one_emergency_contact: "Proporcione al menos un contacto de emergencia:",
      name: "Nombre",
      relationship: "Relación",
      phone: "Teléfono",
      hear_us: "¿Cómo se enteraron de nosotros?",
      website: "Sitio web",
      church_bulletin: "Boletín de la Iglesia",
      facebook: "Facebook",
      school_marquee: "Anuncio escolar",
      Pulpit_church: "Anuncio desde el púlpito en la iglesia",
      referral: "Referencia de un amigo/familiar",
      release_statement:
        "Al marcar las casillas de esta cláusula que inmediatamente a continuación se muestran, nosotros, los participantes del Retiro LOVESTRONG, por la presente, renunciamos y liberamos para siempre a LOVESTRONG Marriage, la Parroquia / Iglesia anfitriona y la Arquidiócesis a la que esta afiliada,  y cualquiera de sus representantes, directores, funcionarios, empleados y sus agentes (colectivamente 'Exonerados') de toda responsabilidad por cualquier pérdida o daño, y cualquier reclamo o demanda por causa de lesiones,  muerte, o daño, o pérdida a la propiedad, ahora y para siempre, que surja o, esté relacionada con la participación y / o presencia de los abajo mencionados en el Retiro Matrimonial LOVESTRONG, incluidas sus sesiones, juntas, actividades y operaciones asociadas que puedan ocurrir, ya sea causadas por la negligencia de los liberados o de otra manera.",
      register: "Registro",
      add_one_name: "Por favor agregue al menos un nombre.",
      least_email_id:
        "Agregue al menos una identificación de correo electrónico.",
      couple_register_retreat_msg: "¡Gracias por registrarse para el retiro!",
      select_state: "Seleccione estado",
      select_parish: "Seleccione Parroquia...",
      mission_statement: "Nuestra Misión:",
      upcoming_retreat: "RETIRO PRÓXIMO",
      retreat_leadership: "Liderazgo del Retiro",
      all_retreat_couples: "Todos los Matrimonios del Retiro",
      all_couples_expected_msg:
        "Se espera que todos los matrimonios del retiro asistan a todas las actividades del fin de semana de {{count}} días.",
      questions: "¿Preguntas?",
      need_help: "¿Necesitas ayuda?",
      retreat_schedule: "Horario del Retiro",
      our_mission: "Nuestra Misión",
      hosting_parish: "Parroquia Anfitriona",
      visit_parish_website: "Visitar el sitio web de la parroquia",
      day: "Dia",
      date: "Fecha",
      start: "Empieza",
      end: "Termina",
      lead_couple: "Pareja Líder",
      co_lead_couple: "Pareja Colíder",
      shadow_lead_couple: "Pareja líder de la sombra",
      spiritual_director: "Director Espiritual (Sacerdote/diácono)",
      spiritual_mentor: "Mentora espiritual",
      mentor_couple: "Pareja Mentora",
      husband_acknowledgment: "Reconocimiento del esposo",
      wife_acknowledgment: "Reconocimiento de la esposa",
      acknowledgmentAlertMsg: "¡Por favor reconozca antes de enviar!",
      release_statement_title: "Declaración de Liberación",
      search_mail_field:
        "Ingrese su dirección de correo electrónico registrada si ya es miembro de Lovestrong:",
      search_mail_placeholder: "Introducir correo electrónico",
      his_name: "Su nombre:",
      his_email: "Su correo electrónico:",
      her_name: "Su nombre:",
      her_email: "Su correo electrónico:",
      alert_msg: "¿Es esta tu información?",
      cancel_button: "No, esta no es nuestra información",
      okay_button: "Sí, esta es nuestra información.",
      register_retreat: "Registrarse Retiro",
      matched_mail:
        "Por favor revisa tu información, puedes editarla y registrarte para el Retiro.",
      not_matched_mail:
        "Ingrese su información en el formulario de registro de retiro a continuación.",
      okay_alert_msg: "Bueno",
      highlighted_text: "(Los campos resaltados en amarillo son obligatorios.)",
      ret_team_selection:
        "Por favor seleccione un participante en retiro o una pareja del equipo.",
      mobile_used: "Este Móvil ya está usado.",
      already_registered:
        "Ya está registrado para este retiro con esta dirección de correo electrónico.",
      mail_already_exist_in_db:
        "Este correo electrónico no existe en la base de datos. Ingrese su información en el formulario a continuación.",
      help: "AYUDA",
      post_a_ticket: "Publicar un ticket",
      first_name: "Nombre de pila",
      last_name: "Apellido",
      message: "Mensaje/Problema",
      enter_captcha: "Introducir captcha",
      enter_your_name: "Ingrese su nombre",
      enter_your_last_name: "Introduce tu apellido",
      enter_your_email: "Introduce tu correo electrónico",
      enter_your_mobile: "Introduce tu número de móvil",
      enter_ticket_subject: "Ingrese el asunto del ticket",
      describe_detail:
        "Asegúrese de explicar su problema, inconveniente o pregunta en detalle…",
      type_captcha_here: "Escribe captcha aquí",
      all_required_fields: "Por favor, rellene todos los campos obligatorios",
      failed_to_create_ticket: "No se pudo crear el ticket",
      subject: "Sujeta",
      invalid_captcha: "Captcha no válido",
      ticket_successfully: "Ticket creado exitosamente",
      cancel: "Cancelar",

      select_category: "Seleccionar categoría",
      ticket_category: "Categoría del ticket",
      retreat_registration: "Inscripción al retiro",
      retreat_financials: "Finanzas del retiro",
      retreat_roster: "Lista del retiro",
      retreat_closure: "Cierre del retiro",
      database_issues: "Problemas de base de datos",
      retreat_reports: "Informes del retiro",
      request_to_feature: "Solicitud de función",
      how_do_i: "¿Cómo puedo...?",
      other: "Otro",
      attachments: "Archivos adjuntos",
      allowed: "(Se permiten JPG, MP4, AVI)",
      selected_files: "Archivos seleccionados",
      invalid_email: "Correo electrónico no válido",
      files_are_invalid: "Estos archivos no son válidos",
      category_reqired: "La categoría es obligatoria",
      three_mb_size: "El tamaño debe ser inferior a 3 MB",
      ten_mb_size: "El tamaño debe ser inferior a 10 MB",
      invalid_type: "(tipo inválido)",
      anniversary_date_required: "¡La fecha de aniversario es obligatoria!",
      dietary_allergies_required:
        "Indique si tiene alergias alimentarias, restricciones dietéticas o cualquier limitación física.",
      parish_required: "¡Se requiere parroquia!",
      Retreat_administrators_tooltip:
        "Los administradores del retiro gestionan los datos del retiro. El líder, el codirector y el mentor actúan como administradores. El superadministrador tiene la autoridad para agregar administradores adicionales.",
      register_new_retreat: "Registrar nuevo retiro",
      enter_Parish_name: "Ingrese el nombre de la parroquia",
      select_retreat_language: "Seleccione el idioma del retiro",
      language_required: "¡Se requiere idioma!",
      enter_location: "Ingresar ubicación",
      location_required: "¡Se requiere ubicación!",
      retreat_theme: "Tema de retiro",
      retreat_theme_required: "¡Se requiere tema de retiro!",
      retreat_img_size: "(El tamaño de la imagen no debe ser mayor a 3 MB.)",
      upload_retreat_image: "Subir imagen de retiro",
      retreat_image_upload_tooltip_size:
  "Dimensiones máximas recomendadas de la imagen:",

retreat_image_upload_tooltip_landscape:
  "Horizontal: 1920 × 1080 px",

retreat_image_upload_tooltip_portrait:
  "Vertical: 1080 × 1620 px",

retreat_image_upload_tooltip_square:
  "Cuadrada: 1620 × 1620 px",

retreat_image_upload_tooltip_file_size:
  "El tamaño del archivo no debe ser mayor a 3 MB.",

retreat_image_upload_tooltip_formats:
  "Formatos aceptados: JPG, JPEG, PNG, WebP y HEIC (si es compatible). No se acepta PDF.",

retreat_image_upload_tooltip_aria:
  "Requisitos para subir la imagen del retiro",
      remove: "Eliminar",
      friday: "Viernes",
      from: "De",
      date_required: "¡Se requiere al menos una fecha!",
      time_from_required: "¡Se requiere tiempo desde!",
      to: "A",
      time_to_required: "¡Se requiere tiempo para!",
      time_from_time_to_should_not_be_same:
        "'Hora desde' y 'Hora hasta' no deben ser iguales.",
      saturday: "Sábado",
      sunday: "Domingo",
      description: "Descripción",
      description_sample: "Descripción Muestra",
      description_sample_tip:
        "Consejo útil: Copie y pegue esta descripción en su formulario de inscripción y asegúrese de cambiar el nombre de la Iglesia, la dirección de correo electrónico y los números de celular por los suyos.",
      description_required: "¡Se requiere descripción!",
      email_message: "Mensaje de correo electrónico",
      email_preview: "Vista previa del correo electrónico",
      sample_email_message: "Ejemplo de mensaje de correo electrónico",
      retreat_payment_link: "Enlace de pago de retiro",
      retreat_team: "Equipo de retiro",
      payment_link_required: "Se requiere enlace de pago",
      contact_information: "Información del contacto",
      enter_name: "Introducir nombre",
      contact_name: "Nombre del contacto",
      contact_name_required: "¡El nombre de contacto es obligatorio!",
      contact_email: "Correo electrónico de contacto",
      contact_email_required:
        "¡El correo electrónico de contacto es obligatorio!",
      mobile_number: "Número de teléfono móvil",
      contact_mobile_required: "¡Se requiere el móvil de contacto!",
      retreat_administrators: "Administradores de retiros",
      location: "Ubicación",
      retreat_file_size: "El tamaño del archivo debe ser inferior a 3 MB",
      preview_email: "Vista previa del correo electrónico",
      no_couple_yet: "No hay parejas añadidas todavía.",
      successfully_retreat_added: "Retiro añadido exitosamente.",
      atleast_one_date_required: "Se requiere al menos una fecha.",
      retreat_already_exists: "El retiro ya existe.",
      close: "Cerca",
      select_create_sub_admin_alert:
        "Seleccione o cree al menos un subadministrador.",
      submit: "Entregar",
      select: "Seleccionar",
      remove_couple: "Eliminar pareja",
      title: "Título",
      first_name_required: "El nombre es obligatorio.",
      email_required: "¡Se requiere correo electrónico!",
      Registration_piritual_director:
        "Inscripción como Director Espiritual (Sacerdote)",
      registration_as_couple: "Registro como Pareja",
      dietary_allergies_priest:
        "¿Tiene alguna alergia alimentaria, restricción alimentaria o limitación física?",
      thank_you_retreat_registration:
        "¡Gracias por registrarse para el retiro!",
      We_will_review_and_confirm:
        "La revisaremos y confirmaremos en el correo electrónico.",
      thank_you_for_prtiest:
        "¡Gracias por el registro al retiro como Director Espiritual (Sacerdote)!",
      check_email_and_verify:
        "Por favor revise su correo electrónico y haga clic en el enlace para verificar su identificación de correo electrónico.",
      couple_register_retreat_msg: "¡Gracias por registrarse para el retiro!",
      wait_confirmation_aAdmin:
        "Espere el correo electrónico de confirmación del administrador.",
      can_login_your_account:
        "Puede iniciar sesión en su cuenta con las siguientes direcciones de correo electrónico registradas:",
      login: "Acceso",
      forget_password: "Olvidé mi contraseña",
      emergency_name_1: "Nombre de emergencia 1",
      emergency_relationship_1: "Relación de emergencia 1",
      emergency_phone_1: "Teléfono de emergencia 1",
      emergency_name_2: "Nombre de emergencia 2",
      emergency_relationship_2: "Relación de emergencia 2",
      emergency_phone_2: "Teléfono de emergencia 2",
      select_existing_couple: "Seleccione una pareja existente",
      select_existing_priest: "Seleccione un sacerdote existente",
      approve: "Aprobar",
      delete: "Borrar",
      create_new_priest: "Agregar nuevo sacerdote",
      spanish_name: "Nombre en español",
      retreat_program: "Programa del Retiro",
      table_of_contents: "TABLA DE CONTENIDO",
      opening_prayer: "Oración de Apertura",
      retreat_lead_team: "Equipo de Liderazgo",
      speakers: "Parejas Oradoras",
      support_teams: "Servicios",
      wisdom_mother_theresa: "Sabiduría de la Madre Teresa",
      wisdom_from_mother_theresa: "Sabiduría de la Madre Teresa",
      spiritual_mentor_couple: "Pareja de Mentores Espirituales",
      guidelines_sharing: "Pautas para compartir y discutir en la mesa",
      guidelines_sharing_table_discussion:
        "Pautas para compartir y discutir en la mesa",
      talk: "Testimonio",
      marriage_prayer_of_protection: "Oración de Protección del Matrimonio",
      lovestrong_donations: "DONACIONES DE LOVESTRONG",
      opening_prayer_content: `<h1 style="text-align: center"><span style="font-size: 36px">LOVESTRONG</span></h1><h2 style="text-align: center;line-height: 2"><span style="font-size: 24px">Oración de Apertura</span></h2><p style="text-align: center"><span style="font-size: 18px"><strong><br></strong></span></p><p style="text-align: center"><span style="font-size: 18px"><strong>Querido Padre Celestial,</strong></span></p><p style="text-align: center"><strong><span style="font-size: 18px">gracias por este día y este momento</span></strong></p><p style="text-align: center"><strong><span style="font-size: 18px">en el que venimos juntos con nuestros esposos y amigos.</span></strong></p><p style="text-align: center"><strong><span style="font-size: 18px">Bendice a este Ministerio a través de Tu dirección, sabiduría y consejo</span></strong></p><p style="text-align: center"><strong><span style="font-size: 18px">para que así pueda florecer y crecer dentro de nuestra comunidad.</span></strong></p><p style="text-align: center"><strong><span style="font-size: 18px">Te pedimos que habite Tu Espíritu dentro de nosotros</span></strong></p><p style="text-align: center"><strong><span style="font-size: 18px">para que seamos siervos humildes y colaboradores</span></strong></p><p style="text-align: center"><strong><span style="font-size: 18px">para que tu gracia pueda fluir abundantemente</span></strong></p><p style="text-align: center"><strong><span style="font-size: 18px">en todos los matrimonios que necesitan Tu ayuda.</span></strong></p><p style="text-align: center"><strong><span style="font-size: 18px">Que Tu presencia siempre esté con nosotros,</span></strong></p><p style="text-align: center"><strong><span style="font-size: 18px">te pedimos esto</span></strong></p><p style="text-align: center"><strong><span style="font-size: 18px">en Tu más precioso y Santo Nombre,</span></strong></p><p style="text-align: center"><span style="font-size: 18px"><strong>Amén</strong></span></p>`,
      prayer_protection_content: `<h1 style="text-align: center"><span style="font-size: 36px">LOVESTRONG</span></h1><h2 style="text-align: center;line-height: 2"><span style="font-size: 24px">Oración de Protección del Matrimonio</span></h2><p style="text-align: center"><span style="font-size: 18px"><strong><br></strong></span></p><p style="text-align: center"><span style="font-size: 18px"><strong>Querido Padre Celestial, te damos gracias por nuestro matrimonio.</strong></span></p><p style="text-align: center"><strong><span style="font-size: 18px">Somos muy bendecidos por tenernos el uno al otro.</strong></span></p><p style="text-align: center"><strong><span style="font-size: 18px">Independientemente de los conflictos que enfrentamos, las pruebas y los desafíos… nuestro matrimonio es una bendición.</span></strong></p><p style="text-align: center"><strong><span style="font-size: 18px">Oramos por Tu protección sobre nuestro matrimonio.</span></strong></p><p style="text-align: center"><strong><span style="font-size: 18px">Te pedimos que fortalezcas nuestra determinación para evitar cualquier camino débil y egoísta.</span></strong></p><p style="text-align: center"><strong><span style="font-size: 18px">Madúranos y refínanos para que solo busquemos el bien del otro.</span></strong></p><p style="text-align: center"><strong><span style="font-size: 18px">También oramos por Tu protección contra las asechanzas del enemigo.</span></strong></p><p style="text-align: center"><strong><span style="font-size: 18px">Espíritu Santo, cúbrenos y unge nuestro matrimonio.</span></strong></p><p style="text-align: center"><strong><span style="font-size: 18px">Guíanos y ayúdanos a amar con fuerza y vivir nuestro Sacramento Matrimonial.</span></strong></p><p style="text-align: center"><strong><span style="font-size: 18px">Que la compasión, el amor y la gracia motiven cada una de nuestras acciones.</span></strong></p><p style="text-align: center"><strong><span style="font-size: 18px">En el nombre de Jesús oramos.</span></strong></p><p style="text-align: center"><span style="font-size: 18px"><strong>¡AMÉN!</strong></span></p>`,
      donations_content: `<h1 style="text-align: center;line-height: 2"><span style="font-size: 33px">DONACIONES DE LOVESTRONG</span><br></h1><p><span style="font-size: 18px">El Ministerio de Matrimonios LOVESTRONG es una organización sin fines de lucro 501(c)(3) que depende enteramente de la asistencia de generosas donaciones de miembros de nuestra comunidad. Este ministerio no puede continuar sin su apoyo. Las cuotas del retiro no cubren todos los gastos que conlleva la realización de estos retiros. Estamos buscando donaciones que se utilizarán de la siguiente manera:</span><br><br><span style="font-size: 20px">Ayuda a LOVESTRONG a crecer aquí en la Iglesia Católica St. Joseph - Honey Creek...</span><br></p><ul><li style="font-size: 18px">Cubriendo la comida, bebidas, cuotas de alquiler del local, impresión de todos los materiales, etc.</li><li style="font-size: 18px">Asegurando suministros para el retiro, materiales de capacitación y organizando eventos de "Noche de Cita de Reencuentro".</li><li style="font-size: 18px">Subsidiando becas para parejas que no pueden pagar el retiro.</li></ul><p style="line-height: 1.3rem"><span style="font-size: 20px">Ayuda a LOVESTRONG a crecer en nuestra comunidad...</span><br></p><ul><li style="font-size: 18px">Organizando retiros de fin de semana en parroquias nuevas y por primera vez.</li><li style="font-size: 18px">Patrocinando retiros gratuitos en parroquias ubicadas en áreas de bajos ingresos.</li></ul><p><br><span style="font-size: 18px">Tenga en cuenta que al usar este código QR, el 80% de su donación se destinará al programa Lovestrong aquí en St. Joseph’s. El 20% se utilizará para apoyar los retiros de divulgación Lovestrong 501(c)(3) en nuestra comunidad.<br><br>Si prefiere donar con cheque o efectivo, su Facilitador de Mesa puede entregarle un formulario y un sobre de donación.</span><br></p>`,
      ministry: "MINISTERIO",
      live_love_strong: "Live. Love. Strong.",
      parish_mission: "Misión de la Parroquia",
      our_parish_mission: "Nuestra Misión Parroquial",
      donations: "Donaciones",
      remove: "Eliminar",
      footer_images: "Imágenes del Pie",
      back_cover_page: "Contraportada",
      back_cover_page_color: "Color de la Contraportada",
      choose_back_cover_page_color: "Elige el Color de la Contraportada",
      download_qr_code: "Descargar Código QR",
      scan_for_more_info: "Escanea para más información",
      download_pdf: "Descargar PDF",
      page: "Página",
      content_not_found_pdf: "No se encontró el contenido para generar el PDF",
      file_downloading: "El archivo se está descargando, por favor espere...",
      file_downloaded: "El archivo se ha descargado.",
      failed_generate_pdf:
        "No se pudo generar el PDF. Por favor, inténtelo de nuevo.",
      edit: "Editar",
      copy_program_link: "Copiar enlace del programa",
      image_upload: "Subir imagen",
      lovestrong_marriage: "Matrimonio LOVESTRONG",
      header: "Encabezado",
      parish_logo: "Logotipo de la Parroquia",
      select_role: "Seleccionar rol",
      select_priest: "Seleccionar sacerdote",
      select_couple: "Seleccionar pareja",
      select_talk: "Seleccionar testimonio",
      select_service: "Seleccionar servicio",
      add_guidelines: "Agregar pautas",
      talks_questions: "Preguntas de los testimonios",
      talk_questions: "Preguntas del testimonio",
      scripture: "Escritura",
      verse_placeholder: "Escribe el versículo",
      citation_example: "Romanos 12:12",
      add_item: "Agregar",
      questions_label: "Preguntas",
      question_placeholder: "Escribe una pregunta",
      no_verses_yet: "Aún no hay versículos.",
      no_questions_yet: "Aún no hay preguntas.",
      delete_this: "¿Eliminar esto?",
      unsaved_worksheet: "Tienes cambios sin guardar.",
      discard: "Descartar",
      keep_editing: "Seguir editando",
      legacy_worksheet_notice:
        "Este testimonio todavía usa el contenido anterior. Al guardar, se reemplaza por escritura y preguntas.",
      move_up: "Subir",
      move_down: "Bajar",
      worksheet_preview: "Vista previa",
      worksheet_editor_hint:
        "Escribe la escritura y las preguntas aquí. Usa el color del texto para cambiar los colores.",
      verse_required: "Escribe el versículo antes de agregarlo.",
      question_required: "Escribe una pregunta antes de agregarla.",
      facebook_link: "Enlace de Facebook",
      instagram_link: "Enlace de Instagram",
      qr_code: "Código QR",
      upload_footer_images: "Subir imágenes del pie",
      alert: "¡¡ALERTA!!",
      confirm_color_change:
        "¿Está seguro de que desea cambiar el color de la contraportada?",
      no: "No",
      couple_suffix: " Pareja",
      save: "Guardar",
      close: "Cerrar",
      example_link: "(ejemplo - https://www.xyz.com)",
      contact_info: "Información del contacto",
      edit_retreat: "Retiro de edición",
      invalid_email_format: "Formato de correo electrónico no válido",
      vaild_email_address:
        "Por favor, introduzca direcciones de correo electrónico válidas.",
    },
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: "english",
    fallbackLng: "spanish",
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
